import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Tools from './components/Tools';
import Table from './components/Table';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Footer from './components/Footer';
import SignUp from './pages/SignUp';
import Purchase from './pages/Purchase';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/404';
import IaParaAdvogados from './pages/ia-para-advogados';
import LawxLegaltechBrasil from './pages/LawxLegaltechBrasil';
import { TRACKING_API_URL } from './config';

function HomePage() {
  useEffect(() => {
    // Track PageView event
    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_name: 'PageView',
      }),
    })
      .then(() => console.log('PageView event tracked'))
      .catch((error) => console.error('Error tracking PageView event:', error));
  }, []);

  return (
    <div className="bg-[#081428] text-white min-h-screen">
      <Navbar />
      <Hero />
      <Features />
      <Tools />
      <Table />
      <Testimonials />
      <Faq />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/purchase" element={<Purchase />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms-of-use" element={<Terms />} />
      <Route path="/ia-para-advogados" element={<IaParaAdvogados />} />
      <Route path="/2024/08/29/lawx-legaltech-brasil" element={<LawxLegaltechBrasil />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
